import React from 'react';
import { If } from '../../../../Atoms/Conditionals';
import { FooterProps } from '../types';

const HeroFooter: React.FC<FooterProps> = ({
  platformText,
  platformLogos,
  statistics,
  classname = '',
}) => {
  return (
    <div
      className={`py-12 bg-white w-full lg:pt-[55px] lg:pb-[55px] md:pb-10 ${classname}`}
    >
      <div className=" flex justify-between wg-container px-20 sm:block md:block  mx-auto opacity-0 translate-y-12 animate-[footerEnter_1s_ease-out_forwards] animate-delay-600">
        <div className="sm:flex sm:flex-col md:flex md:flex-col sm:items-center md:items-center sm:justify-center md:justify-center md:pb-10 sm:pt-0 sm:pb-8">
          <div className="text-[#4b5159] text-xl flex gap-[14px] sm:text-sm sm:text-center md:text-center lg:text-base md:text-base">
            {platformText}
          </div>

          <div className="flex gap-5 pb-2 justify-center pt-1 items-center">
            <If condition={platformLogos && platformLogos.length > 0}>
              {platformLogos.map((logo, index) => (
                <div key={index}>
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className={logo.alt === 'whatsapp' ? 'h-10' : ''}
                  />
                </div>
              ))}
            </If>
          </div>
        </div>

        <div className="flex gap-[72px] sm:px-0 sm:gap-0 sm:justify-between md:gap-0 justify-evenly">
          <If condition={statistics && statistics.length > 0}>
            {statistics.map((stat, index) => (
              <div
                key={index}
                className="sm:flex sm:flex-col sm:justify-between sm:items-center"
              >
                <div className="font-semibold text-s-40 text-center text-brand-1000 lg:text-4xl sm:text-2xl md:text-s-36">
                  {stat.value}
                </div>
                <div className="font-medium text-xl text-[#4b5159] text-center lg:text-base md:text-base sm:text-sm sm:w-[90%]">
                  {stat.label}
                </div>
              </div>
            ))}
          </If>
        </div>
      </div>
    </div>
  );
};

export default HeroFooter;
